import MoonLoader from 'react-spinners/MoonLoader'

const Loader = () => {
    return <div className="h-screen flex items-center justify-center">
        <MoonLoader color='#FF3D00' />
    </div>
}

export default Loader